import { updateObject } from '../../utils/utility';

const initialState = {};

const updateFilterDetail = (state = initialState, action) => {
    const { value, filterType,tableType } = action;
    let filters={...state};
    if( state["tableType"] && state["tableType"]!=tableType){
        filters={};
    }
    filters["tableType"]=tableType;
    filters[filterType]=value;
    return updateObject(state,{...filters});
};

const reducer = (state = initialState, action) => {
    if (action.type === "UPDATE_FILTER_DETAIL") {
        return updateFilterDetail(state, action);
    }else if(action.type=="RESET_TABLE_FILTER"){
        return updateObject(initialState);
    }
    return state;
}

export default reducer;